import { PolicyBillV2 } from "@hagerty/customer-insurance-gateway-client";

import { getFormattedDate } from "../../utils/getFormattedDate";

type HdcBillCategory = "1.0" | "1.5";

const autoPay: Partial<PolicyBillV2> = {
  autoPayDetails: { last4: "1234", paymentPlanPeriod: "ANNUAL" },
  isAutoPay: true,
};

const autoPayFailed: Partial<PolicyBillV2> = {
  autoPayDetails: { last4: "1234", paymentPlanPeriod: "ANNUAL" },
  dueDate: getFormattedDate({ days: -7 }),
  isAutoPay: true,
  status: "FAILED",
};

const pastDue: Partial<PolicyBillV2> = {
  dueDate: getFormattedDate({ days: -7 }),
  status: "PAST_DUE",
};

const upcoming: Partial<PolicyBillV2> = {
  dueDate: getFormattedDate({ days: 7 }),
  status: "HAS_BILL",
};

const hdcBill = (category: HdcBillCategory): Partial<PolicyBillV2> => ({
  category: category === "1.5" ? "HDC1DOT5" : "HDC1DOT0",
  productDetails: [`Membership ${category}`],
});

const revalBill: Partial<PolicyBillV2> = {
  revalOffer: {
    endorsement: {
      number: "1",
      status: "SAVE",
    },
    premium: {
      current: "5000",
      new: "7500",
      difference: "2500",
    },
    policyName: "policyName",
    policyNumber: "policyNumber",
    vehicles: [],
  },
};

export const createCigBill = (bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  alignedBill: undefined,
  autoPayDetails: undefined,
  amount: 5000,
  category: "INSURANCE",
  clientKey: "self-service",
  currency: "USD",
  dueDate: getFormattedDate({ days: 7 }),
  id: "1",
  isAutoPay: false,
  payUrl: "https://hagerty.com",
  productDetails: ["1960 Ford Mustang"],
  productNumber: "1",
  revalOffer: undefined,
  source: bill.source ?? "CORE",
  status: "HAS_BILL",
  totalAmount: 5000,
  ...bill,
});

export const cigAutoPayFailedBill = (bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...autoPayFailed,
});

export const cigAutoPayBill = (bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...autoPay,
});

export const cigPastDueBill = (bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...pastDue,
});

export const cigUpcomingBill = (bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...upcoming,
});

export const cigRevalBill = (bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...revalBill,
});

export const cigHdcAutoPayFailedBill = (category: HdcBillCategory, bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...autoPayFailed,
  ...hdcBill(category),
});

export const cigHdcAutoPayBill = (category: HdcBillCategory, bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...autoPay,
  ...hdcBill(category),
});

export const cigHdcPastDueBill = (category: HdcBillCategory, bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...pastDue,
  ...hdcBill(category),
});

export const cigHdcUpcomingBill = (category: HdcBillCategory, bill: Partial<PolicyBillV2>): PolicyBillV2 => ({
  ...createCigBill(bill),
  ...upcoming,
  ...hdcBill(category),
});
